import {CLOSE_OVERLAY, OPEN_OVERLAY} from './overlayTypes';

const initialState = {
   display: 'none',
   bgcolor: 'secondary.main',
   boxShadow: 3,
   color: 'text.primary',
   position: 'fixed',
   zIndex: 'drawer',
   children: null,
   bottom: 0,
   left: '15%',
   p: 1
};

function msgReducer(state = initialState, action) {
   switch (action.type) {
      case OPEN_OVERLAY:
         return {...state, display: 'block', ...action.payload};
      case CLOSE_OVERLAY:
         return initialState;
      default:
         return state;
   }
}

export default msgReducer;
